module.exports = __webpack_public_path__ + "img/IMG_2369.4c533061.jpg";